import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    logo: "she_face",
    logoStep: 6,
    drawer: false,
    email: "",
    name: "",
    minBar: true,
    fullName: "",
    expertise: ""
  },
  getters: {
    showFace: state => {
      if (state.drawer) {
        return 'watching'
      } else {
        return state.logo
      }
    }
  },
  mutations: {
    changeFace: state => {
      state.logoStep++
      if (state.logoStep === 18) state.logoStep = 1
      if (state.logoStep === 1) state.logo = 'happy'
      if (state.logoStep === 2) state.logo = 'thinking'
      if (state.logoStep === 3) state.logo = 'dyin'
      if (state.logoStep === 4) state.logo = 'tuned'
      if (state.logoStep === 5) state.logo = 'shocked'
      if (state.logoStep === 6) state.logo = 'she_face'
      if (state.logoStep === 7) state.logo = 'watching'
      if (state.logoStep === 8) state.logo = 'gamer'
      if (state.logoStep === 9) state.logo = 'thought'
      if (state.logoStep === 10) state.logo = 'uni'
      if (state.logoStep === 11) state.logo = 'look'
      if (state.logoStep === 12) state.logo = 'holy'
      if (state.logoStep === 13) state.logo = 'ooh'
      if (state.logoStep === 14) state.logo = 'gear'
      if (state.logoStep === 15) state.logo = 'mulah'
      if (state.logoStep === 16) state.logo = 'lens'
      if (state.logoStep === 17) state.logo = 'love'
    },
    resetFace: state => {
      state.logo = 'she_face'
    }
  },
  actions: {}
});
